import { createContext, useContext, useState } from "react";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);

  const addToCart = (product) => {
    setCart((prev) => {
      const existing = prev.find((item) => item.product_id === product.id);
      if (existing) {
        return prev.map((item) =>
          item.product_id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prev, { product_id: product.id, name: product.name, price: product.price, quantity: 1, image_url: product.image_url, type: product.type || 'standard', shipping: product.shipping || 0, file_id: product.file_id || null }];
    });
    setIsCartOpen(true);
  };

  const removeFromCart = (productId) => {
    setCart((prev) => prev.filter((item) => item.product_id !== productId));
  };

  const updateQuantity = (productId, quantity) => {
    if (quantity <= 0) {
      removeFromCart(productId);
      return;
    }
    setCart((prev) =>
      prev.map((item) =>
        item.product_id === productId ? { ...item, quantity } : item
      )
    );
  };

  const clearCart = () => setCart([]);

  const cartSubtotal = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const calculateShipping = (cartItems) => {
    let standardItemCount = 0;
    let heavyShipping = 0;
    cartItems.forEach(item => {
      if (item.type === 'tent') {
        heavyShipping += 250.00 * item.quantity;
      } else {
        standardItemCount += item.quantity;
      }
    });
    let standardShipping = 0;
    if (standardItemCount > 0) {
      standardShipping = 12.00;
      if (standardItemCount > 3) {
        standardShipping += (standardItemCount - 3) * 3.00;
      }
    }
    return standardShipping + heavyShipping;
  };

  const TAX_RATE = 0.07;
  const cartTax = parseFloat((cartSubtotal * TAX_RATE).toFixed(2));
  const cartShipping = calculateShipping(cart);
  const cartTotal = cartSubtotal + cartTax + cartShipping;

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQuantity, clearCart, cartSubtotal, cartTax, cartShipping, cartTotal, cartCount, isCartOpen, setIsCartOpen }}>
      {children}
    </CartContext.Provider>
  );
};
